import React, { useMemo, useState } from "react";
import EmptyState from "../shared/EmptyState";

// ============================================================
// Audit Log tab — inside Analytics, visible to Super Admin + Limited
// Admin only (the parent page already guards this). Shows a searchable,
// time-descending table of audit entries.
// ============================================================
export default function AuditLogTab({ audit }) {
  const [q, setQ] = useState("");
  const sorted = useMemo(
    () => [...(audit || [])].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)),
    [audit]
  );
  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return sorted;
    return sorted.filter(a =>
      (a.userName || "").toLowerCase().includes(s) ||
      (a.action || "").toLowerCase().includes(s) ||
      (a.detail || "").toLowerCase().includes(s)
    );
  }, [sorted, q]);

  return (
    <div data-testid="analytics-audit-tab">
      <div className="audit-toolbar">
        <div className="analytics-inline-count">{filtered.length} of {sorted.length} entries</div>
        <input
          type="search"
          data-testid="audit-search"
          placeholder="Search by user, action, or detail…"
          value={q}
          onChange={e => setQ(e.target.value)}
          className="audit-search"
        />
      </div>
      <div className="audit-table-wrap">
        <div className="audit-table-scroll">
        <table className="audit-table" data-testid="audit-table">
          <thead>
            <tr><th>Timestamp</th><th>User</th><th>Action</th><th>Detail</th></tr>
          </thead>
          <tbody>
            {filtered.map(a => (
              <tr key={a.id} data-testid={`audit-row-${a.id}`}>
                <td className="audit-ts">{new Date(a.timestamp).toLocaleString()}</td>
                <td><span className="badge badge-charcoal">{a.userName}</span></td>
                <td className="audit-action">{a.action}</td>
                <td className="audit-detail">{a.detail}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
        {filtered.length === 0 && (
          <EmptyState
            data-testid="audit-empty"
            icon="lock"
            title={q ? "No entries match your search" : "No audit entries yet"}
            subtitle={q
              ? "Try clearing the search box or use a different keyword."
              : "Actions taken across the app will appear here for admin review."}
          />
        )}
      </div>
    </div>
  );
}
